const MetaIcon = ({ width = 60, height = 60 }) => (
  <img
    src="/metaIcon.png"
    width={width}
    height={height}
    alt="Meta Icon"
    style={{ display: 'block' }}
  />
);

export default MetaIcon;